"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var radio_1 = __importDefault(require("relements/build/esm/input/radio"));
var Slider_1 = __importDefault(require("@src/components/Slider"));
var FeedbackFrequency_1 = __importDefault(require("../Components/FeedbackFrequency"));
var constants_1 = require("../constants");
var getCategoryTitle = function (categoryHint) {
    var categoryTitle = '';
    constants_1.CategoryOptions.forEach(function (_a) {
        var title = _a.title, hint = _a.hint;
        if (categoryHint == hint)
            categoryTitle = title;
    });
    return categoryTitle;
};
var invisibleInput = function (feedbackCategory) { return feedbackCategory === 4; };
var FEEDBACK_SETTINGS = {
    title: 'User Feedback',
    className: 'userFeedbackBlock',
    inputs: [
        {
            label: '',
            key: 'collectUserFeedback',
            component: radio_1["default"],
            className: 'full-width',
            props: function (data, meta, onChange) {
                var feedback_config = data.feedback_config;
                var feedback_category = feedback_config.feedback_category, feedback_delay = feedback_config.feedback_delay;
                return {
                    invisible: false,
                    value: {
                        title: getCategoryTitle("" + feedback_category),
                    },
                    onChange: function (value) {
                        onChange('feedback_config', __assign(__assign(__assign({}, feedback_config), { feedback_category: parseInt(value.hint, 10) }), (feedback_delay === null && { feedback_delay: 10 })));
                        if (feedback_delay === null) {
                            onChange('feedback_delay', 10);
                        }
                    },
                    options: constants_1.CategoryOptions,
                };
            },
        },
        {
            label: 'Feedback Frequency',
            key: 'collectFeedbackMultiple',
            component: FeedbackFrequency_1["default"],
            className: 'full-width',
            props: function (data, meta, onChange) {
                var feedback_config = data.feedback_config;
                var feedback_category = feedback_config.feedback_category, multiple_feedbacks = feedback_config.multiple_feedbacks;
                return {
                    invisible: invisibleInput(feedback_category) || feedback_category === 3,
                    value: {
                        title: !multiple_feedbacks ? 'One Time' : 'Multiple Times',
                    },
                    onChange: function (value) {
                        onChange('feedback_config', __assign(__assign({}, feedback_config), { multiple_feedbacks: value.title === 'Multiple Times' }));
                        onChange(constants_1.INPUT_BLOCK_KEYS.MULTIPLE_FEEDBACKS, value.title === 'Multiple Times');
                    },
                    options: [
                        {
                            title: 'One Time',
                            hint: 'This will collect feedback only once through a users lifetime.',
                        },
                        {
                            title: 'Multiple Times',
                            hint: 'This will enable multiple feedback collection after every chat completion. Repetitive feedback won’t be collected if the feedback is collected in last 2 hrs.',
                        },
                    ],
                };
            },
        },
        {
            label: 'Delay in Seconds',
            key: 'delayInSeconds',
            component: Slider_1["default"],
            className: 'full-width',
            props: function (data, meta, onChange) {
                var feedback_config = data.feedback_config;
                var feedback_category = feedback_config.feedback_category, feedback_delay = feedback_config.feedback_delay;
                return {
                    value: feedback_delay !== null && feedback_delay !== void 0 ? feedback_delay : 0,
                    invisible: invisibleInput(feedback_category) || feedback_category === 3,
                    min: 0,
                    max: 1200,
                    step: 1,
                    marginTop: '32px',
                    width: '500px',
                    info: constants_1.delayInfo,
                    onChange: function (e) {
                        onChange('feedback_config', __assign(__assign({}, feedback_config), { feedback_delay: e.target.valueAsNumber }));
                        onChange('feedback_delay', e.target.valueAsNumber);
                    },
                };
            },
        },
        {
            label: 'Cool down period in minutes',
            key: 'coolDownPeriod',
            component: Slider_1["default"],
            className: 'full-width',
            props: function (data, meta, onChange) {
                var feedback_config = data.feedback_config;
                var feedback_category = feedback_config.feedback_category, feedback_cooldown_period = feedback_config.feedback_cooldown_period, multiple_feedbacks = feedback_config.multiple_feedbacks;
                return {
                    value: feedback_cooldown_period !== null && feedback_cooldown_period !== void 0 ? feedback_cooldown_period : 0,
                    invisible: invisibleInput(feedback_category) ||
                        feedback_category === 3 ||
                        !multiple_feedbacks,
                    min: 15,
                    max: 120,
                    step: 1,
                    marginTop: '22px',
                    marginBottom: '22px',
                    width: '500px',
                    info: constants_1.coolDownPeriodInfo,
                    onChange: function (e) {
                        return onChange('feedback_config', __assign(__assign({}, feedback_config), { feedback_cooldown_period: e.target.valueAsNumber }));
                    },
                };
            },
        },
    ],
};
exports["default"] = FEEDBACK_SETTINGS;
